import { IssuerMapping } from '@zero/shared/util-models';

export const ISSUER_MAPPING: IssuerMapping = {
  'UniCredit Bank AG': 'HVB',
  'HSBC Trinkaus & Burkhardt AG': 'HSBC',
  'HSBC Trinkaus & Burkhardt GmbH': 'HSBC',
  'Goldman Sachs': 'GS',
  GMS: 'GS',
  'Goldman, Sachs & Co. Wertpapier GmbH': 'GS',
  'Goldman Sachs Bank Europe SE': 'GS',
  'Vontobel Financial Products GmbH': 'Vontobel',
  VONT: 'Vontobel',
  VT: 'Vontobel',
  'Morgan Stanley & Co. International plc': 'Morgan Stanley',
  MS: 'Morgan Stanley',
  'UBS AG, Niederlassung London': 'UBS',
  UBS: 'UBS',
};
